export const FACTURACION = {
  CREDITO: 'credito',
  CONTADO: 'contado',
}

export const TIPOS_FACTURACION = {
  CREDITO: 'Crédito',
  CONTADO: 'Contado',
}
